import { ValueFormatterParams } from 'ag-grid-community';

export const numberFormatter = (params: ValueFormatterParams) => {
    if (!params?.value) return '';
    return new Intl.NumberFormat('nl-NL').format(params.value);
};
